import React from "react";
import "./FeedMobileBar.scss";

const FeedMobileBar = ({
  locations = [],
  marketLabel,
  mode,
  marketPickerOpen,
  onToggleMarketPicker,
  locationSearch,
  onSelectAll,
  onSelectMatches,
  onOpenFilters,
  activeFilterCount = 0,
  selectedProperty,
  selectedPropertyLabel,
  matchCount,
  onClearProperty,
}) => {
  const inMatchMode = mode === "match";

  return (
    <div className="feed-mobile-bar d-md-none">
      {/* Editing the market in place, the way the desktop rail does it, rather
          than behind a sheet. The chips carry their own remove control, so
          adding and subtracting cities and ZIPs happens without leaving the
          feed. */}
      {marketPickerOpen ? (
        <div className="feed-mobile-bar__market-editor">
          {locationSearch}
          <button
            type="button"
            className="feed-mobile-bar__market-done"
            onClick={onToggleMarketPicker}
          >
            Done
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="feed-mobile-bar__market"
          onClick={onToggleMarketPicker}
          aria-expanded={false}
        >
          <span className="feed-mobile-bar__pin" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 21s7-5.686 7-11a7 7 0 1 0-14 0c0 5.314 7 11 7 11Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </span>
          <span className="feed-mobile-bar__market-label">
            {locations.length ? marketLabel : "Add city, zip, or area"}
          </span>
          <span className="feed-mobile-bar__market-edit">
            {locations.length > 1 ? `Edit (${locations.length})` : "Edit"}
          </span>
        </button>
      )}

      <div className="feed-mobile-bar__row">
        {/* The match flow used to live behind a control labelled "Sort and
            Filter", so an agent had no reason to believe it was there. */}
        <div className="feed-mobile-bar__segmented" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={!inMatchMode}
            className={`feed-mobile-bar__seg ${!inMatchMode ? "is-active" : ""}`}
            onClick={onSelectAll}
          >
            All buyer want-listings
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={inMatchMode}
            className={`feed-mobile-bar__seg ${inMatchMode ? "is-active" : ""}`}
            onClick={onSelectMatches}
          >
            My matches
          </button>
        </div>

        <button
          type="button"
          className={`feed-mobile-bar__filters ${activeFilterCount > 0 ? "has-filters" : ""}`}
          onClick={onOpenFilters}
          aria-label={
            activeFilterCount > 0
              ? `Sort and filter, ${activeFilterCount} active`
              : "Sort and filter"
          }
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 6h16M7 12h10M10 18h4"
              stroke="currentColor"
              strokeWidth="1.9"
              strokeLinecap="round"
            />
          </svg>
          {activeFilterCount > 0 && (
            <span className="feed-mobile-bar__filter-count">
              {activeFilterCount}
            </span>
          )}
        </button>
      </div>

      {inMatchMode && selectedProperty && (
        // Two sibling buttons under a div, not a clear button nested inside the
        // property button - that is invalid HTML and a tab stop inside a button.
        <div className="feed-mobile-bar__property">
          <button
            type="button"
            className="feed-mobile-bar__property-main"
            onClick={onSelectMatches}
            aria-label={`Change property, currently ${selectedPropertyLabel}`}
          />
          <span className="feed-mobile-bar__property-addr">
            {selectedPropertyLabel}
          </span>
          {matchCount > 0 && (
            <span className="feed-mobile-bar__property-count">
              {matchCount} {matchCount === 1 ? "match" : "matches"}
            </span>
          )}
          <button
            type="button"
            aria-label="Clear property"
            className="feed-mobile-bar__property-clear"
            onClick={() => onClearProperty?.()}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default FeedMobileBar;
